import React from 'react';
import { observer } from 'mobx-react';
import { scrollToTop } from '../../utils/scrollUtils';
import TrendsView from './TrendsView';

@observer
export default class TrendsPage extends React.Component {
    componentDidMount() {
        scrollToTop();
    }

    render() {
        const store = this.props.rootStore.trends;
        const actions = this.props.actions.trends;

        return (
            <TrendsView
                loadMorePosts={actions.loadMorePosts}
                loadPosts={actions.loadPosts}
                store={store}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/trends/index.jsx